import React from "react";
import PlutoLogo from "./PlutoLogo";
import PlutoLogoGray from "/icons/pluto_logo_gray.svg";

const Footer: React.FC = () => {
  return (
    <div className="mt-auto pb-8 pt-2 flex justify-center z-10 bg-white select-none">
      <div className="flex flex-row items-center text-text-secondary dark:text-text-secondary-dark select-none">
        <span className="select-none font-mono text-xs mr-2">Secured by</span>
        <a
          href="https://pluto.xyz"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-pluto-logo  no-underline transition-colors select-none cursor-pointer "
        >
          <img src={PlutoLogoGray} alt="Pluto Logo" className="w-17" />
          {/* <div className="ml-1.5 ">
            <span
        
              className="flex items-center select-none "
            >
              <PlutoLogo size="w-3 h-4" className="text-pluto-logo" />
            </span>
          </div>
          <span
        
            className="ml-1 text-pluto-logo  no-underline transition-colors select-none "
          >
            PLUTO
          </span> */}
        </a>
      </div>
    </div>
  );
};

export default Footer;
